module.exports = __webpack_public_path__ + "static/media/icon_instagram.e3be7cfd.svg";